var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "example-avatar" },
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.comp_Parent_Property) +
          _vm._s(_vm.getConfirmBoxResponse) +
          "\n  "
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$refs.upload && _vm.$refs.upload.dropActive,
              expression: "$refs.upload && $refs.upload.dropActive",
            },
          ],
          staticClass: "drop-active",
        },
        [_c("h3", [_vm._v("Drop files to upload")])]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.edit,
              expression: "!edit",
            },
          ],
          staticClass: "row avatar-upload ",
        },
        [
          _c("div", { staticClass: "col-md-5" }, [
            _c("div", { staticClass: "text-center" }, [
              _c("span", { staticStyle: { display: "none" } }, [
                _vm._v(_vm._s(_vm.com_gett_deletededfile)),
              ]),
              _c("span", { staticStyle: { display: "none" } }, [
                _vm._v(" " + _vm._s(_vm.com_gett_uploadedfile)),
              ]),
              _c("span", { staticStyle: { display: "none" } }, [
                _vm._v(" " + _vm._s(_vm.com_default_logo_url)),
              ]),
              _c("label", { attrs: { for: "avatar" } }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12 uploaded-image-box" }, [
                    _c("img", {
                      staticClass: "rounded-circle",
                      attrs: {
                        src: _vm.uploadesImageUrl
                          ? _vm.uploadesImageUrl
                          : _vm.default_logo_url,
                      },
                    }),
                    _vm.imagecount > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "multi-image",
                            on: { click: _vm.listImages },
                          },
                          [
                            _vm._v(
                              "\n                +" +
                                _vm._s(_vm.imagecount) +
                                "\n              "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        ref: "dropdownImageList",
                        staticClass: "multi-images-list",
                        class: _vm.showimglist ? "block" : "none",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-12" },
                          _vm._l(_vm.UploadedImage, function (item, index) {
                            return _vm.UploadedImage
                              ? _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-8 p-0 text-left image-name",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.getdownloadfileUrl,
                                            "data-toggle": "tooltip",
                                            "data-original-title":
                                              item.Image_Name,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.viewFile(
                                                item.file_key,
                                                "file"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.Image_Name))]
                                      ),
                                      _c("span", [
                                        _vm._v(_vm._s(item.Uploaded_date)),
                                      ]),
                                    ]
                                  ),
                                  _c("div", { staticClass: "col-md-2" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: _vm.getdownloadfileUrl },
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewFile(
                                              item.file_key,
                                              "file"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons view-image",
                                            attrs: {
                                              "data-toggle": "tooltip",
                                              "data-original-title": "View",
                                            },
                                          },
                                          [_vm._v("visibility")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "col-md-2" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteImage(
                                              item.unique_id,
                                              item.encounter_id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons delete-image",
                                            attrs: {
                                              "data-toggle": "tooltip",
                                              "data-original-title": "Delete",
                                            },
                                          },
                                          [_vm._v("delete")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ])
                              : _vm._e()
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "col-md-7 flex" }, [
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _vm.show_remove_logo_button
                  ? _c(
                      "button",
                      {
                        staticClass: "btn  secondary-btn btn-input",
                        staticStyle: { display: "none" },
                        on: {
                          click: function ($event) {
                            return _vm.RemoveStaffprofilepicture()
                          },
                        },
                      },
                      [_vm._v("\n          Remove\n        ")]
                    )
                  : _vm._e(),
                _c(
                  "file-upload",
                  {
                    ref: "upload",
                    staticClass: "primary-btn ripple btn-center",
                    attrs: {
                      extensions: "gif,jpg,jpeg,png,webp",
                      accept: "image/png,image/gif,image/jpeg,image/webp",
                      name: "staffpicupload",
                      drop: !_vm.edit,
                      "input-id": "file2",
                    },
                    on: {
                      "input-filter": _vm.inputFilter,
                      "input-file": _vm.inputFile,
                    },
                    model: {
                      value: _vm.staffpicfile,
                      callback: function ($$v) {
                        _vm.staffpicfile = $$v
                      },
                      expression: "staffpicfile",
                    },
                  },
                  [_vm._v("\n          Upload\n        ")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.staffpicfile.length && _vm.edit,
              expression: "staffpicfile.length && edit",
            },
          ],
          staticClass: "avatar-edit",
        },
        [
          _vm.staffpicfile.length
            ? _c("div", { staticClass: "avatar-edit-image" }, [
                _c("img", {
                  ref: "editImage",
                  attrs: { src: _vm.staffpicfile[0].url },
                }),
              ])
            : _vm._e(),
          _c("div", { staticClass: "text-center p-2" }, [
            _c(
              "button",
              {
                staticClass: "btn secondary-btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.cancelUpload()
                  },
                },
              },
              [_vm._v("\n        Cancel\n      ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn primary-btn",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.editSave.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n        Save\n      ")]
            ),
          ]),
        ]
      ),
      _c("ConfirmBox", {
        ref: "confirmcomp",
        attrs: { showmodal: _vm.showCnfrmPopUp, actionmessage: _vm.actionMsg },
        on: {
          cancelAction: function ($event) {
            _vm.showCnfrmPopUp = false
            _vm.confrmPopUpResponse = false
          },
          confirmAction: function ($event) {
            _vm.showCnfrmPopUp = false
            _vm.confrmPopUpResponse = true
          },
        },
      }),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isdisplaymsg
            ? _c("Messages", {
                attrs: {
                  datamessage: _vm.sucessmsgtext,
                  isVisible: this.isdisplaymsg,
                },
                on: { closemsg: _vm.closeMessage },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("div"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }